import React, { useState } from 'react';
import { Container, Button } from 'react-bootstrap';
import SettingsTable from '../../../../components/tables/SettingsTable';

const Beneficiaries = () => {
  // Sample data generator
  const generateSampleData = (count = 40) => {
    const names = [
      'Rajesh Kumar', 'Priya Sharma', 'Amit Patel', 'Sneha Reddy',
      'Vikram Singh', 'Anjali Gupta', 'Rahul Verma', 'Neha Joshi'
    ];
    const banks = ['HDFC Bank', 'ICICI Bank', 'SBI', 'Axis Bank', 'Kotak Bank'];
    const statuses = ['Verified', 'Pending', 'Rejected'];
    
    return Array.from({ length: count }, (_, i) => ({
      id: `BEN${String(i + 1).padStart(4, '0')}`,
      beneficiaryName: names[Math.floor(Math.random() * names.length)],
      accountNumber: `${Math.floor(Math.random() * 9000000000000000) + 1000000000000000}`,
      ifscCode: `${banks[i % banks.length].substring(0, 4).toUpperCase().replace(/\s/g, '')}0${String(Math.floor(Math.random() * 1000000)).padStart(6, '0')}`,
      bankName: banks[Math.floor(Math.random() * banks.length)],
      mobile: `+91 ${Math.floor(Math.random() * 9000000000) + 1000000000}`,
      userId: `USER${String(Math.floor(Math.random() * 500) + 1).padStart(4, '0')}`,
      status: statuses[Math.floor(Math.random() * statuses.length)],
      addedDate: new Date(2024, Math.floor(Math.random() * 12), Math.floor(Math.random() * 28) + 1)
        .toISOString().split('T')[0]
    }));
  };

  const [data] = useState(generateSampleData(40));

  // Column definitions
  const columns = [
    {
      key: 'actions',
      label: 'Actions',
      render: (row) => (
        <div className="d-flex gap-1 justify-content-center">
          <Button 
            size="sm" 
            className="btn-outline-primary-custom"
            title="Edit"
            style={{
              padding: '0.25rem 0.5rem'
            }}
          >
            <i className="bi bi-pencil"></i>
          </Button>
        </div>
      )
    },
    { key: 'id', label: 'Beneficiary ID' },
    { key: 'beneficiaryName', label: 'Beneficiary Name' },
    { key: 'accountNumber', label: 'Account Number' },
    { key: 'ifscCode', label: 'IFS Code' },
    { key: 'bankName', label: 'Bank Name' },
    { key: 'mobile', label: 'Mobile' },
    { key: 'userId', label: 'User ID' },
    { key: 'status', label: 'Status' },
    { key: 'addedDate', label: 'Added Date' }
  ];

  return (
    <Container fluid className="">
      <SettingsTable
        data={data}
        settingsType="Beneficiaries"
        columns={columns}
      />
    </Container>
  );
};

export default Beneficiaries;

